const pagination = {
  state: {
      pageCount: 9,//只能是奇数
      pageSizes: [2,10,20,50,100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000],
      pageSize: 50,
  },
  mutations: {
    SET_PAGECOUNT: (state, data) => {
      state.pageCount = data;
    },
    SET_PAGESIZES: (state, data) => {
      state.pageSizes = data;
    },
    SET_PAGESIZE: (state, data) => {
      state.pageSize = data;
    },
  },
  actions: {
    setPageCount({ commit }, data) {
      commit("SET_PAGECOUNT", data);
    },
    setPageSizes({ commit }, data) {
      commit("SET_PAGESIZES", data);
    },
    setPageSize({ commit }, data) {
      commit("SET_PAGESIZE", data);
    },
  },
  getters: {
      pageCount: (state) => state.pageCount,
      pageSizes: (state) => state.pageSizes,
      pageSize: (state) => state.pageSize,
  },
};
  export default pagination;
  


// WEBPACK FOOTER //
// ./src/store/mutations/pagination.js